import React, { memo } from "react";
import CustomModal from "../../../../../components/CustomModal/CustomModal";
import Icon from "../../../../../components/Icon";
import "./styles.css";
import Datalayer from "../../../../../libs/vendors/data-layer";
import {
    CLICK_ACTIONS,
    CLICK_DESCRIPTION,
    MODAL_NAMES,
    MODAL_TYPES,
} from "../../../../../constants/datalayer";
import Button from "../../../../../components/Button/Button";
import housingIcon from '../../../../../assets/images/icons/housing-assets.svg';
const HouseThingsModal = ({ show, handleOnClose }) => {
    const onCloseModal = () => {
        Datalayer.sendModal(
            MODAL_TYPES.INFO,
            `${MODAL_NAMES.COVERAGE_TYPES}: Casa + Cosas`,
            `${CLICK_ACTIONS.SELECT}: ${CLICK_DESCRIPTION.GO_BACK}`
        );
        handleOnClose(0);
    };

    return (
        <CustomModal isShowing={show} onClose={handleOnClose}>
            <div className="things-house-modal">
                <Icon name="housing-assets" image={housingIcon} />
                <div className="things-house-modal__title">Casa + Cosas</div>
                <div className="things-house-modal__content">
                    Puedes proteger <b>la estructura más todas las cosas y</b>
                    <br />
                    <b> bienes de alto valor</b> que están dentro de tu casa o
                    departamento.
                </div>
            </div>
            <div className="things-house-modal__footer">
                <Button outline kind="secondary" onClick={onCloseModal}>
                    Volver
                </Button>
            </div>
        </CustomModal>
    );
};

export default memo(HouseThingsModal);
